import _defineProperty from "/Users/tannermarshall/Dev/figure53.dev/websites/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/Users/tannermarshall/Dev/figure53.dev/websites/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/tannermarshall/Dev/figure53.dev/websites/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/Users/tannermarshall/Dev/figure53.dev/websites/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/Users/tannermarshall/Dev/figure53.dev/websites/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/Users/tannermarshall/Dev/figure53.dev/websites/node_modules/@babel/runtime/helpers/esm/inherits.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import Honeybadger from '@honeybadger-io/js';
export { default as Honeybadger } from '@honeybadger-io/js';
import React, { Component } from 'react';
function DefaultErrorComponent(_ref) {
  var error = _ref.error,
    info = _ref.info;
  return React.createElement("div", {
    className: 'error'
  }, React.createElement("div", null, "An Error Occurred"), React.createElement("div", null, error ? error.toString() : ''), React.createElement("div", null, info ? JSON.stringify(info, null, 2) : ''));
}
var HoneybadgerErrorBoundary = /*#__PURE__*/function (_Component) {
  function HoneybadgerErrorBoundary(props) {
    var _this;
    _classCallCheck(this, HoneybadgerErrorBoundary);
    _this = _callSuper(this, HoneybadgerErrorBoundary, [props]);
    _this.state = {
      error: null,
      info: null,
      errorOccurred: false
    };
    return _this;
  }
  _inherits(HoneybadgerErrorBoundary, _Component);
  return _createClass(HoneybadgerErrorBoundary, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      this.props.honeybadger.afterNotify(function (error, _notice) {
        if (!error && _this2.props.showUserFeedbackFormOnError) {
          _this2.props.honeybadger.showUserFeedbackForm();
        }
      });
    }
  }, {
    key: "componentDidCatch",
    value: function componentDidCatch(error, errorInfo) {
      this.setState({
        error: error,
        info: errorInfo
      });
      this.props.honeybadger.notify(error, {
        context: errorInfo
      });
    }
  }, {
    key: "getErrorComponent",
    value: function getErrorComponent() {
      return this.props.ErrorComponent ? React.createElement(this.props.ErrorComponent, _objectSpread({}, this.state)) : React.createElement(DefaultErrorComponent, _objectSpread({}, this.state));
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(React.Fragment, null, this.state.errorOccurred ? this.getErrorComponent() : this.props.children);
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError(error) {
      return {
        error: error,
        errorOccurred: true,
        info: null
      };
    }
  }]);
}(Component);
HoneybadgerErrorBoundary.defaultProps = {
  showUserFeedbackFormOnError: false
};
var NOTIFIER = {
  name: '@honeybadger-io/react',
  url: 'https://github.com/honeybadger-io/honeybadger-js/tree/master/packages/react',
  version: '6.1.27'
};
Honeybadger.setNotifier(NOTIFIER);
export { HoneybadgerErrorBoundary };